import {api} from "../../../../api/API";
import {GlazingCustomItem, GlazingDoorGroup, GlazingScreenGroup, GlazingSubmittal} from "../../../../api/ElevationTool";
import {GlazingSection} from "./GlazingSectionPage";

// the glazing sections for the given openings, with each section's elevation drawing resolved to a
// printable image. Shared by the glazing submittal and the shop-drawing submittal's lite kit pages.
export async function loadGlazingSections(props: {
    project: number;
    alternative?: number;
    openings: number[];
}): Promise<{screens: GlazingSection[]; doors: GlazingSection[]; custom: GlazingCustomItem[]}> {
    return resolveGlazingSections(await api.elevationTool.glazingSubmittal(props));
}

// the printable sections for an already-fetched glazing response.
export async function resolveGlazingSections(data: GlazingSubmittal): Promise<{screens: GlazingSection[]; doors: GlazingSection[]; custom: GlazingCustomItem[]}> {
    const screens = await Promise.all(data.screens.map(toScreenSection));
    const doors = await Promise.all(data.doors.map(toDoorSection));

    return {screens: screens, doors: doors, custom: data.custom || []};
}

async function toScreenSection(group: GlazingScreenGroup): Promise<GlazingSection> {
    return {
        projectName: group.projectName,
        heading: sectionHeading(group.name, group.label),
        image: await api.print.fileAsImage({file: group.rendering}),
        panels: group.panels,
        openings: group.openings,
    };
}

async function toDoorSection(group: GlazingDoorGroup): Promise<GlazingSection> {
    return {
        projectName: group.projectName,
        heading: sectionHeading(group.name, group.label),
        image: await api.print.fileAsImage({file: group.rendering}),
        lites: group.lites,
        openings: group.openings,
    };
}

// "{elevation}-{sub-label}", matching the elevation names printed on the shop-drawing submittal's
// drawing tiles. The sub-label tells apart variants of one elevation, which are separate sections
// here because they need different glass.
function sectionHeading(name: string, label: string): string {
    return label ? `${name}-${label}` : name;
}
